import { render, staticRenderFns } from "./ButtonType.vue?vue&type=template&id=50a6c946&"
import script from "./ButtonType.vue?vue&type=script&lang=ts&"
export * from "./ButtonType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports